export enum DIALOG_TYPES {
  SHOW_CREDENTIALS,
  CREATE_CREDENTIALS,
  REGENERATE_CREDENTIALS,
  DELETE_CREDENTIALS,
  CREATE_SUB_USER,
  DELETE_SUB_USER,
  CREATE_SUB_USER_KEY,
  SHOW_SUB_USER_KEY_SECRET,
  DELETE_SUB_USER_KEY
}

export enum TABS {
  CREDENTIALS,
  BROWSER
}

// `data-tour` values of the elements the page tour points at
export enum TOUR_ANCHORS {
  PRINCIPAL_ARN = "object-storage-principal-arn",
  ENDPOINT = "object-storage-endpoint",
  CREDENTIALS_TAB = "object-storage-credentials-tab",
  BROWSER_TAB = "object-storage-browser-tab",
  CREDENTIALS_TABLE = "object-storage-credentials-table",
  CREATE_CREDENTIALS = "object-storage-create-credentials",
  SUB_USERS_TABLE = "object-storage-sub-users-table",
  CREATE_SUB_USER = "object-storage-create-sub-user",
  BUCKETS = "object-storage-buckets"
}
